import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import IconoKpi from "../../../../../assets/icons/icono-kpi.png";
import {
  InfoCard,
  InfoIcon,
  InfoTitle
} from "../../../../../components/atoms/InfoCard";
import { DateRangeContext } from "../../context/DateRangeContext";
import { RefreshContext } from "../../context/RefreshContext";
import { useGetHorasMaquinaRangoFechas } from "../../hooks/useGetHorasMaquinaRangoFechas";
import "./ProduccionKpis.css";
import { calculateDaysBetweenDates } from "../../../../../commons/utiles";
import { getJumboInfo } from "../../lib/utils";
import { KpiCard } from "./KpiCard";
import { SkeletonKpisCards } from "./SkeletonKpisCards";

export function ProduccionKpis() {
  const { t } = useTranslation();
  const { finalDate } = useContext(DateRangeContext);
  const { refreshKey } = useContext(RefreshContext);
  const { startDate, endDate } = finalDate;

  const { idMaquina, idMina } = getJumboInfo();

  const { horas, loadingHoras, errorHoras } = useGetHorasMaquinaRangoFechas(
    idMaquina,
    startDate,
    endDate,
    idMina,
    refreshKey
  );

  const { detalles, promedios } = horas;

  const amountsOfDays = calculateDaysBetweenDates(startDate, endDate);

  return (
    <section className="section-kpis">
      <InfoCard style={{ marginBlockEnd: "10px" }}>
        <InfoIcon
          style={{ width: "35px" }}
          src={IconoKpi}
        />
        <InfoTitle>{t("kpi_produccion")}</InfoTitle>
      </InfoCard>
      <section className="kpis-cards-container">
        {loadingHoras && !errorHoras && (
          <SkeletonKpisCards amountOfDays={amountsOfDays} />
        )}
        {!loadingHoras && !errorHoras && (
          <section className="kpis-cards">
            {detalles?.map((card) => (
              <KpiCard
                key={card.id}
                title={card.titulo}
                metricas={card.metricas}
              />
            ))}
          </section>
        )}
        {!loadingHoras &&
          !errorHoras &&
          (!promedios || promedios.length !== 0) && (
            <section className="kpis-cards">
              {promedios?.map((card) => (
                <KpiCard
                  key={card.id}
                  title={card.titulo}
                  metricas={card.metricas}
                />
              ))}
            </section>
          )}
      </section>
    </section>
  );
}
